import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-domainfieldslist",
  templateUrl: "./domainfieldslist.component.html",
  styleUrls: ["./domainfieldslist.component.scss"],
})
export class DomainfieldslistComponent implements OnInit {
  // displayedColumns: string[] = ['action', 'name', 'label', 'datatype', 'defaultvalue', 'description', 'active'];
  displayedColumns = [
    "action",
    "name",
    "label",
    "datatype",
    "sortorder",
    "defaultvalue",
    "minvalue",
    "maxvalue",
    "deprecated",
    "active",
  ];
  isLoading = false;
  isError = false;
  errorMessage = "";
  dataSource: "";
  domainfields: any;
  sectionkey: string = "";
  sectionid: string = "";

  //  sectionid: string = '';
  //   section: string = '';

  constructor(
    private toastrService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private location: Location
  ) {}

  ngOnInit() {
    this.getDomainfieldslist();

    this.route.params.subscribe((params) => {
      this.sectionkey = params["section"];
      this.sectionid = params["id"];
      // this.sectionid = this.route.snapshot.params.id;
      //   this.section = this.route.snapshot.params.section;
      console.log("Domain Item:", this.sectionkey);
      console.log("Domain ID:", this.sectionid);
    });

    // this.sectionkey = this.route.snapshot.params.sectionkey;
    // this.sectionid = this.route.snapshot.params.id;
    // console.log("Domain Item:", this.sectionkey);
    // console.log("Domain ID:", this.sectionid);
  }

  cancel() {
    this.router.navigateByUrl("home/domainsettinglist");
    // this.location.back();
  }

  // new() {
  //     this.router.navigateByUrl("home/domainsettingfields/new");
  // }
  new() {
    // const section = this.route.snapshot.paramMap.get('section');
    // const id = this.route.snapshot.paramMap.get('id');
    this.router.navigateByUrl(
      `/home/domainsettingfields/new/${this.sectionkey}/${this.sectionid}`
    );
  }

  editApp(element: any) {
    this.router.navigateByUrl(
      `/home/domainsettingfields/edit/${this.sectionkey}/${this.sectionid}/${element.id}`
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  //   editApp(element: any ) {
  //   this.router.navigateByUrl('/home/domainsettingfields/edit/' + element.id)
  // }

  getDomainfieldslist() {
    return new Promise((resolve, reject) => {
      console.log("getDomainSettingsection");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");

      const id = this.route.snapshot.paramMap.get("id");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      console.log("org id", organizationid);
      console.log("domain", domain);
      console.log("subdomain", subdomain);
      this.isLoading = true;
      this.dataService

        .getAllDomainFeilds(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.domainfields = res.data.domainsettingfields;
              console.log("Doneeee****", this.domainfields);

              if (this.domainfields != null) {
                this.dataSource = this.domainfields.map((domainfields) => ({
                  id: domainfields.id,

                  name: domainfields.name,
                  label: domainfields.label,
                  datatype: domainfields.datatype,
                  sortorder: domainfields.sortorder,
                  defaultvalue: domainfields.defaultvalue,
                  picklistvalues: domainfields.picklistvalues,
                  minvalue: domainfields.minvalue,
                  maxvalue: domainfields.maxvalue,
                  deprecated: domainfields.deprecated,
                  active: domainfields.active,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  delete(id: any, type: any) {
    // alert(id)
    // const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteDomainSettingFields(id, type, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")

            this.showSuccess(res.message);
            this.isLoading = false;

            // window.location.reload();
            this.getDomainfieldslist();
          } else {
            console.log("Failed to delete!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }
}
